import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  visible: false,
  message: '',
  severity: ''
};

export const snackbarReducer = createReducer(initialState, {
  [types.SNACKBAR_OPEN](state, action) {
    return {
      ...state,
      visible: true,
      message: action.response.message,
      severity: action.response.severity
    };
  },
  [types.SNACKBAR_CLOSE](state) {
    return {
      ...state,
      visible: false
    };
  }
});
